module.exports = __webpack_public_path__ + "static/img/illustratepic_02.166f99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ko/illustratepic_02.png
// module id = rzyT
// module chunks = 1